module.exports = __webpack_public_path__ + "img/Misaligned Logo.1b5ffd70.png";